import React from 'react';
import { Link } from 'react-router';
import _ from 'i18n';
import Lottie from "react-lottie";
import * as error404Data from "./lottie-animations/error-404.json";
import * as nothingFoundData from "./lottie-animations/nothing-found.json";
import connect from "react-redux/es/connect/connect";

const defaultOptions = {
  loop: true,
  autoplay: true,
};

const NotFoundPage = ({ mainClass, children, text, isErrorPage }) => {

  const inIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  const isInIframe = inIframe();

  const renderedTxt = isErrorPage ? (
    <div className={"not-found__main"}>
      <Lottie
        options={{ ...defaultOptions, animationData: error404Data }}
        height={360}
        isClickToPauseDisabled={true}
      />
      <h2>{_("PAGE_NOT_FOUND")}</h2>
      {!isInIframe && (
        <button className="btn secondary mt-4">
          <i className="icon-arrow-left"></i> &nbsp;&nbsp;&nbsp;&nbsp;
          <Link to="/">{_('goBackToHome')}</Link>
        </button>
      )}
    </div>
  ) : (
    <div className={"not-found__main"}>
      <Lottie
        options={{ ...defaultOptions, animationData: nothingFoundData }}
        height={300}
        isClickToPauseDisabled={true}
      />
      <h3>{_("Nothing Found")}</h3>
      <p>{_(text || "nothing_found")}</p>
    </div>
  );

  return (
    <div className={`not-found ${mainClass}`}>
      {children || renderedTxt}
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPage);


// WEBPACK FOOTER //
// ./app/components/NotFoundPage.js